import messages from '@intlify/unplugin-vue-i18n/messages';
import { formatRelative, intlFormat } from 'date-fns';
import { enCA, frCA } from 'date-fns/locale';
import type { Ref } from 'vue';
import { createI18n } from 'vue-i18n';

import { Constants } from '@/constants';
import { LocalizableString, type Locales } from '@/services/types/api.types';

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: Constants.DefaultLocale,
  fallbackLocale: Constants.DefaultLocale,
  messages: messages,
});

export function setLocale(locale: Locales): void {
  i18n.global.locale.value = locale;
}

export function currentLocale(): Locales {
  return i18n.global.locale.value as Locales;
}

export function useCurrentLocale(): Ref<Locales> {
  return i18n.global.locale as Ref<Locales>;
}

export function formatDate(date: string | number | Date | null): string {
  if (!date) return '';
  return intlFormat(date, { dateStyle: 'long' }, { locale: currentLocale() });
}

export function formatDateRelative(date: string | number | Date | null): string {
  if (!date) return '';
  const locale = (() => {
    switch (i18n.global.locale.value) {
      case 'en':
        return enCA;
      case 'fr':
      default:
        return frCA;
    }
  })();
  return formatRelative(date, new Date(), { locale });
}

export function getSupportedLocales(): Locales[] {
  return Object.keys(new LocalizableString()) as Locales[];
}
